angular
  .module 'gym.components'
  .directive 'signedWaiverTacs', ->
    restrict: 'EA'
    scope:
      waiver: '='
      collapsible: '='
      defaultCollapsed: '='
    template: require('templates/components/waivers/signed_waiver_tacs.html.slim')
